// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectsList_wrapper__ZuBWv"};